import React from 'react'
import '../pages/css/Home.css';
import Entertaiment1 from '../images/gaming1.jpeg';
import Entertaiment2 from '../images/gaming2.png';
import Entertaiment3 from '../images/gaming3.jpg';
import banner from '../images/gaming-banner.jpg';

function EntertainmentGaming() {
    return (
        <>   <section
            id="contact-section-page"
            style={{
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative', // Important for overlay
                zIndex: 1,
            }}
        >
            {/* Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // semi-transparent black
                    zIndex: 2,
                }}
            ></div>

            <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-10">
                        <h1 className="fw-bold display-5 text-white" style={{ fontSize: '3.5rem' }}>Entertainment Gaming Experience
                        </h1>
                        <p className="fs-2 fw-medium text-white mt-3">
                            Build next-gen gaming platforms and immersive entertainment apps that engage users through interactivity, storytelling, and real-time performance.
                        </p>
                    </div>
                </div>
            </section>
        </section>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our  <span className="highlight-orange">Entertainment Gaming</span> Services
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Game Development & Streaming Platforms */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={Entertaiment1}
                            alt="Gaming & Streaming Platforms"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Gaming &</span> Entertainment
                        </h1>
                        <p className="mb-4">
                            <h2>We create immersive gaming, streaming, and media platforms for next-gen digital experiences.</h2>
                        </p>

                        <h6 className="fw-bold mb-2 highlight-orange">Key Highlight:</h6>
                        <p className="mb-4 ps-3">
                            <h4>From real-time multiplayer games to scalable OTT platforms, our custom solutions deliver performance, interactivity, and global reach.</h4>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Video Streaming, OTT, VR Solutions */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Entertainment</span> Platforms
                        </h1>

                        <p className="mb-4">
                            <h2>Design, develop, and scale OTT, video-on-demand, and VR platforms for audience engagement and monetization.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">OTT & VOD</h4>
                        <p className="mb-2 ps-3">
                            <h5>Build Netflix-like streaming platforms with adaptive bitrate, CDN integration, and subscription systems.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Virtual Reality Experiences</h4>
                        <p className="mb-2 ps-3">
                            <h5>Create immersive VR content for gaming, events, or virtual concerts across platforms like Oculus and WebXR.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Digital Rights Management (DRM)</h4>
                        <p className="mb-2 ps-3">
                            <h5>Secure your content using Widevine, FairPlay, and custom DRM layers for global media distribution.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Audience Analytics</h4>
                        <p className="mb-2 ps-3">
                            <h5>Track engagement, viewer retention, and revenue performance with real-time dashboards and user insights.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={Entertaiment2}
                            alt="OTT and VR Entertainment Solutions"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Gaming Infrastructure, Multiplayer Engines, Leaderboards */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={Entertaiment3}
                            alt="Multiplayer Game Development"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Multiplayer</span> Game Engines
                        </h1>

                        <p className="mb-4">
                            <h2>We design backend infrastructure, engines, and logic for multiplayer, real-time, and cross-platform games.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Game Server Architecture</h4>
                        <p className="mb-2 ps-3">
                            <h5>Deploy scalable match-based game servers with real-time sync, WebSocket handling, and serverless logic.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Cross-Platform Development</h4>
                        <p className="mb-2 ps-3">
                            <h5>Develop games in Unity, Unreal, or React Native with shared logic across Android, iOS, and web.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Leaderboard & Rewards</h4>
                        <p className="mb-2 ps-3">
                            <h5>Implement secure leaderboards, player stats, badge systems, and dynamic reward mechanisms.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </section>

        </>

    )
}

export default EntertainmentGaming